import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import searchIcon from './../../../../assets/onboard-images/Search_Icon.png';
import { useHistory } from 'react-router-dom';
import { getAquaaAdminChannelsData, getAquaaAdminContactTypeTableData, updateAquaaAdminContactTypeDataStart } from '../../../../actions/Applications/aquaa.action';
import AdminBreadcrumb from '../../../../components/Administration/General/Admin-breadcrumb';
import { OnboardSelect } from '../../../../components/Onboard/OnboardComponents/Dropdown/Select';

const AquaaAdminContactType = () => {
      const dispatch = useDispatch();
      const history = useHistory();
   const aquaaAdminChannelsData = useSelector((state) => state.aquaaReducer.aquaaAdminChannelsData);
   const aquaaAdminContactTypeTableData = useSelector((state) => state.aquaaReducer.aquaaAdminContactTypeTableData);
  
      const [isRefreshClicked, setIsRefreshedClicked] = useState(false); 
      const [selectedChannel, setSelectedChannel] = useState();  
      const [filter, setFilter] = useState('');
      let searchColumns = ['contactForm'];
      const [formData, setFormData] = useState({
          contactTypeForm: ''
        });
    
       useEffect(()=> {
              dispatch(getAquaaAdminChannelsData());
           dispatch(getAquaaAdminContactTypeTableData());
             }, [dispatch]);

             const handleFormDataChange = (key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value, // Update specific key in formData
    }));
  };

   const handleAddAccount = async () => {

    // Dispatch the action to update data
    dispatch(updateAquaaAdminContactTypeDataStart([{ ContactType: formData.contactTypeForm, Channel: selectedChannel }]));
    dispatch(getAquaaAdminContactTypeTableData());
    setFormData({ contactTypeForm: '' });
  setSelectedChannel(null);
  setIsRefreshedClicked(true);
    // Fetch the updated data
    dispatch(getAquaaAdminContactTypeTableData());

  };

const columns = aquaaAdminContactTypeTableData && aquaaAdminContactTypeTableData.length > 0 ? Object.keys(aquaaAdminContactTypeTableData[0]) : [];

const data = aquaaAdminContactTypeTableData

 function searchRows(rows) {
    return rows.filter((row) =>
      searchColumns.some(
        (column) =>
          row[column]
            .toString()
            .toLowerCase()
            .indexOf(filter.toLowerCase()) > -1,
      ),
    );
  }
  console.log('aquaaAdminContactTypeTableData',aquaaAdminContactTypeTableData)
  return (
   <section>
       <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/aquaaapplications')} label2='AQuAA' isActive3={true}
        value3={() => history.push('/aquaaadminonboardlanding')} label3='AQuAA Admin' isActive4={false} label4='ContactType Form'/>
         <section className="App_Layout" style={{ marginBottom: '20px' }}>
           <div className="Applications_Title"> ContactType Form </div>
         </section>
            <section className='App_Layout'>
          <main className='Title_bar'>
           <div className='TicketNoInput'>
            <div><label>ContactType Form</label></div>
            <input
              type="text"
              placeholder="Example: 0123456789"
              value={formData.contactTypeForm}
              onChange={(e) => handleFormDataChange('contactTypeForm', e.target.value)}  // Bind to formData.ticketNumber
            />
          </div>
          <main className='Aquaa_dropdown'>
                     <label HtmlFor='country'>Channel</label>
                     <OnboardSelect data={aquaaAdminChannelsData} name='channel' value='channel' id='RoleId' marginTop='10px'
                       editValue='' addValueToQueue= {(name, value) => { setSelectedChannel(value); setIsRefreshedClicked(false) }} refresh={isRefreshClicked} />
                   </main>
          <div className='btn_adduser' onClick={handleAddAccount}>Add</div>
          </main>
         </section>
          <div> <span className='search_bar_AdminFlow'>
                                   <input className='search_input_AdminFlow' value={filter || ''} onChange={e => setFilter(e.target.value)} placeholder='Search ContactType Form' />
                                   <button className='search_icon_AdminFlow'><img src={searchIcon} alt='' /> </button>
                                 </span></div>
          <br/> <br/> 
     <table className="aquaa-table">
  <thead>
    <tr>
      {columns.map((col, index) => (
        <th key={index}>{col}</th>
      ))}
    </tr>
  </thead>
  <tbody>
    {data && data.length > 0 ? (
      searchRows(data).map((row, rowIndex) => (
        <tr key={rowIndex}>
          {columns.map((col, colIndex) => {
            const cellData = row[col]; // row['account_Name']
            return <td key={colIndex}>{cellData}</td>;
          })}
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={columns.length}>
          <section>
            <div className="noData-para" style={{ marginTop: 0 }}>
              <div style={{ marginTop: 30 }}>
                No data available, please try different filters or contact the admin
              </div>
            </div>
          </section>
        </td>
      </tr>
    )}
  </tbody>
</table>
         </section>
  )
}

export default AquaaAdminContactType